// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3mo_h","selected":"Chip_selected__2ogb4"};